<template>
  <div class="o-table__body">
    <div
      class="o-table__body__item"
      :class="{
        'o-table__body__item--active':
          checkedList.find((c) => c[checkedKey] === item[checkedKey]) !==
          undefined,
        'u-flex-wrap-wrap o-table__body__item--small-table': smallTable,
      }"
      v-for="(item, i) in items"
      :key="'b' + i"
      @click="$emit('click:row', item)"
    >
      <div v-if="checkable || singleCheckable" class="es-xs-1">
        <Checkbox
          @change="$emit('change:checked', item)"
          :value="
            checkedList.find((c) => c[checkedKey] === item[checkedKey]) !==
            undefined
          "
        ></Checkbox>
      </div>
      <div
        v-for="(header, j) in headers"
        :key="i + '-' + j"
        class="u-margin-top-small-sm-down"
        :class="`
              ${header.col ? `es-xs-${header.col}` : ''}
              ${header.sm ? `es-sm-${header.sm}` : ''}
              ${header.md ? `es-md-${header.md}` : ''}
              ${header.lg ? `es-lg-${header.lg}` : ''}
              ${header.xl ? `es-xl-${header.xl}` : ''}
              ${header.xxl ? `es-xxl-${header.xxl}` : ''}`"
      >
        <slot
          :item="item"
          :index="i"
          :name="header.value"
          v-if="$scopedSlots[header.value]"
        ></slot>
        <div v-else>
          {{ i18n ? $t(item[header.value]) : item[header.value] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "@base/Inputs/Checkbox.vue";
export default {
  components: { Checkbox },
  props: {
    items: {
      default: () => [],
    },
    headers: {
      default: () => [],
    },
    checkedList: {
      default: () => [],
    },
    allChecked: {
      default: false,
    },
    checkable: {
      default: false,
    },
    singleCheckable: {
      default: false,
    },
    smallTable: {
      default: false,
    },
    scrollLeft: {
      default: 0,
    },
    checkedKey: {
      default: "id",
    },
    i18n: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    SET_SCROLL_EVENT(e) {
      this.$emit("change:scroll", e.target.scrollLeft);
      document.getElementById("table-header").scrollLeft = e.target.scrollLeft;
      const bodies = document.querySelectorAll(".overflow-x-scroll");
      for (let i = 0; i < bodies.length; i++) {
        const el = bodies[i];
        el.scrollLeft = e.target.scrollLeft;
      }
    },
  },
};
</script>

<style></style>
